module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-arrow-left"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16d8426a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArrowLeftIcon.vue
// module id = 429
// module chunks = 1